import Token from '@/utils/Token';

export default {

    parse(data) {
        return data;
    },

    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/upload/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/upload/list${params}`, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/upload/${id}`, Token.getHeader());
    },
}